/*=========================================================================================
  File Name: module-customsdeclaration-getters.js
  Description: Customs Declaration Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: DQDUY
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	getCustomDeclaration(state) {
		return state.CustomsDeclaration;
	},
	getCustomDeclarationTotal(state) {
		return state.CustomsDeclarationTotal;
	},
	IsLoadingTotalRecords(state) {
		return state.IsLoadingTotalRecords;
	},
	/**
	 * Lấy danh sách tờ khai được chọn từ Vuex store
	 * @param {Object} state - Vuex state
	 * @returns {Array} Danh sách tờ khai được chọn
	 * @author dqduy 09.02.2026
	 */
	getSelectedDeclarations(state) {
		return state.selectedDeclarations;
	}
};
